import { CompanyLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  ProfileName,
  LogoutText,
  BigScreen,
  SmallScreen,
  LogoutIcon,
  Row,
  AgentTag,
  // AgentPortalText,
} from "./Styles";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import useUser from "../../../hooks/useUser";
import { navigate } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import useSettings from "../../../hooks/useSettings";
import styled, { css } from "styled-components";

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default function StyledAppBar({
  sidebarOpen,
  onToggleSidebar,
  showSidebar,
}) {
  const classes = useStyles();
  const { userObject, token, setToken, authSetting } = useUser();
  const { showAlert, hideAlert } = useAlert();
  const { setting, settingsLoading } = useSettings();

  const handleLogout = () =>
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        setToken("logged_out");
        hideAlert();
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        {showSidebar && (
          <HamburgerBtn
            onClick={onToggleSidebar}
            title={sidebarOpen ? "Hide sidebar" : "Show sidebar"}
            $open={sidebarOpen}
          >
            <Bar $open={!sidebarOpen} $pos="top" />
            <Bar $open={!sidebarOpen} $pos="mid" />
            <Bar $open={!sidebarOpen} $pos="bot" />
          </HamburgerBtn>
        )}

        <LogoContainer>
          {settingsLoading ? null : (
            <CompanyLogo
              onClick={() => navigate("/dashboard")}
              src={
                authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
              }
            />
          )}
        </LogoContainer>
        <BigScreen>
          <LinksContainer>
            {!token ? null : (
              <>
                <Row onClick={handleLogout}>
                  <LogoutIcon
                    src={require("../../../assets/images/logout.svg")}
                  />
                  <LogoutText>{labels.logout}</LogoutText>
                </Row>
                <ProfileImage
                  src={
                    userObject.avatarUrl
                      ? userObject.avatarUrl
                      : require("../../../assets/images/userPlaceholder.svg")
                  }
                />

                <ProfileName>
                  <div>{userObject.name}</div>
                  <AgentTag>Admin</AgentTag>
                </ProfileName>
              </>
            )}
          </LinksContainer>
        </BigScreen>
        <SmallScreen>
          {!token ? null : (
            <>
              <Row onClick={handleLogout}>
                <LogoutIcon
                  src={require("../../../assets/images/logout.svg")}
                />
                <LogoutText>{labels.logout}</LogoutText>
              </Row>
              <ProfileImage
                src={
                  userObject.avatarUrl
                    ? userObject.avatarUrl
                    : require("../../../assets/images/userPlaceholder.svg")
                }
              />

              <ProfileName>{userObject.name}</ProfileName>
            </>
          )}
        </SmallScreen>
      </Toolbar>
    </AppBar>
  );
}

const HamburgerBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e1e3ee;
  background: ${(p) => (p.$open ? "#f0f4ff" : "#ffffff")};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #f0f4ff;
    border-color: #a5b4fc;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Bar = styled.span`
  display: block;
  height: 2px;
  border-radius: 2px;
  background: #293461;
  transition: all 0.25s ease;

  ${(p) =>
    p.$pos === "top" &&
    css`
      width: ${p.$open ? "16px" : "16px"};
      transform: ${p.$open ? "translateY(7px) rotate(45deg)" : "none"};
    `}

  ${(p) =>
    p.$pos === "mid" &&
    css`
      width: 12px;
      opacity: ${p.$open ? 0 : 1};
      transform: ${p.$open ? "scaleX(0)" : "none"};
    `}

  
  ${(p) =>
    p.$pos === "bot" &&
    css`
      width: ${p.$open ? "16px" : "16px"};
      transform: ${p.$open ? "translateY(-7px) rotate(-45deg)" : "none"};
    `}
`;
